<div class="error">
    <h1>404 - Page Not Found</h1>
    <mat-icon>search_off</mat-icon>
    <p>
        Sorry, we have a formal proof that the page you are looking for does not exist. <br>
        It might have been moved.
    </p>
    <a routerLink="/">Go back to Home</a>
</div>